import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AiPromptUseCase } from '../../admin/types/AiPromptConfig';
import { useAuth } from '../../auth/context/AuthContext';
import { PermissionScopes } from '../../auth/permissions';
import { usePlanEntitlements } from '../../billing/planEntitlements';
import styles from './TaskAgentUseCaseLink.module.css';

const taskAgentUseCasePath = `/ai/config?tab=${encodeURIComponent(AiPromptUseCase.TaskAgent)}`;

export const TaskAgentUseCaseLink: React.FC = () => {
  const { t } = useTranslation('tasks');
  const { hasPermission } = useAuth();
  const { hasFeature } = usePlanEntitlements();
  const canOpen = hasPermission(PermissionScopes.aiConfigRead) && hasFeature('aiEmployees');

  if (!canOpen) {
    return null;
  }

  return (
    <Link className={styles.link} to={taskAgentUseCasePath}>
      <span className={styles.mark} aria-hidden="true">
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
          <path d="M9 1.5l1.35 3.9 3.9 1.35-3.9 1.35L9 12.15 7.65 8.1 3.75 6.75l3.9-1.35L9 1.5z" fill="currentColor" />
          <path d="M14.2 11.2l.55 1.55 1.55.55-1.55.55-.55 1.55-.55-1.55-1.55-.55 1.55-.55.55-1.55z" fill="currentColor" opacity="0.85" />
        </svg>
      </span>
      <span className={styles.copy}>
        <span className={styles.title}>{t('openTaskAgentUseCase')}</span>
        <span className={styles.hint}>{t('openTaskAgentUseCaseHint')}</span>
      </span>
      <span className={styles.chevron} aria-hidden="true">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M6 3.5L10.5 8 6 12.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </span>
    </Link>
  );
};
